import React from 'react';
import { Link } from 'react-router-dom'

const ComputerMenu = (props) => {
    return (

        <div id="ComputerMenu1" className="page1">
            <div className="wrapper">
                <div className="pageTitle">
                    <a className="backButton" href="#"></a>
                    <h1>Levels</h1>
                </div>
                <ul className="buttonList">
                    <li>
                        <a href="#Game/Classic/Easy" className="button buttonEasy">
                            Easy
                        </a>
                    </li>
                    <li>
                        <a href="#Game/Classic/Medium" className="button buttonMedium">
                            Medium
                        </a>
                    </li>
                    <li>
                        <a href="#Game/Classic/Hard" className="button buttonHard">
                            Hard
                        </a>
                    </li>
                    <li>
                        <a href="#Game/Classic/CrazyNinja" className="button buttonCrazyNinja">
                            Crazy Ninja
                        </a>
                    </li>

                </ul>

            </div>
        </div>
    )
};

export default ComputerMenu;

